import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: [
            "!font-sans !bg-white",
            "!border !border-stone-100",
            "!shadow-[0_8px_32px_rgba(0,0,0,0.06),_0_2px_8px_rgba(0,0,0,0.04)]",
            "!rounded-2xl !py-3.5 !px-4",
            "!min-w-[300px]",
          ].join(" "),
          title: "!text-sm !font-semibold !text-[hsl(152,45%,9%)] !leading-snug",
          description: "!text-xs !text-stone-500 !leading-relaxed",
          success: "!border-l-[3px] !border-l-emerald-500",
          error: "!border-l-[3px] !border-l-rose-500",
          warning: "!border-l-[3px] !border-l-amber-500",
          info: "!border-l-[3px] !border-l-[hsl(147,46%,33%)]",
          actionButton:
            "!bg-[hsl(147,46%,33%)] !text-white !text-xs !font-medium !rounded-full !px-3",
          cancelButton:
            "!bg-stone-100 !text-stone-600 !text-xs !font-medium !rounded-full !px-3",
          closeButton:
            "!border-stone-200 !text-stone-400 hover:!text-stone-600 hover:!bg-stone-50",
          icon: "!mt-0",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
